// Cookie consent storage and helpers.
// Consent must be given before any non-essential cookie (e.g. Microsoft
// Clarity) is loaded, so nothing outside this module may set those cookies.

const CONSENT_STORAGE_KEY = "cookieConsent";
const CONSENT_VERSION = 1;

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (parsed?.version !== CONSENT_VERSION) return null;

    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent({ analytics }) {
  const consent = {
    version: CONSENT_VERSION,
    analytics: !!analytics,
    decidedAt: new Date().toISOString(),
  };

  localStorage.setItem(
    CONSENT_STORAGE_KEY,
    JSON.stringify(consent)
  );

  return consent;
}
